import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { DealerProfile } from '@app/domain/model/dealer-profile';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-admin-dealer-info',
  templateUrl: './admin-dealer-info.component.html',
  styleUrls: ['./admin-dealer-info.component.scss']
})
export class AdminDealerInfoComponent implements OnInit, OnDestroy {

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  profile: DealerProfile;

  isWindowToLow: boolean;

  constructor(private route: ActivatedRoute,
              private readonly router: Router) {
    this.router.events.pipe(takeUntil(this.destroyed$)).subscribe((evt) => {
      if(evt instanceof NavigationEnd) {
        setTimeout(()=> {
          this.isWindowToLow = window.innerHeight < document.body.offsetHeight && window.innerHeight + 100 > document.body.offsetHeight;
        }, 20);
      }
    });
  }

  ngOnInit() {
    this.route.data.pipe(takeUntil(this.destroyed$)).subscribe(({profile}) => {
      this.profile = profile;
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  backToSearchResults() {
    const searchParams = JSON.parse(localStorage.getItem('searchParams'));

    this.router.navigate(['/admin/search'], {queryParams: searchParams});
  }

  goUp() {
    window.scrollTo(0, 0);
  }

}
